import React from 'react';
const features = [{
  icon: '🎯',
  title: 'Playbook Visual HD',
  desc: '12 sistemas diagramados para mostrar en el tiempo muerto.'
}, {
  icon: '📋',
  title: '15 Pizarras Tácticas',
  desc: 'Rotaciones, zonas de saque y estadísticas listas.'
}, {
  icon: '🤚',
  title: '20 Señales Visuales',
  desc: 'Comunicación secreta entre entrenador y armador.'
}, {
  icon: '📱',
  title: 'Video-Scouting Express',
  desc: 'Analiza al rival con el celular en minutos.'
}];
export function EliteSection() {
  return <section className="w-full bg-[#0A0A0F] py-16 px-4" data-id="element-28">
      <div className="max-w-4xl mx-auto" data-id="element-29">
        <div className="text-center mb-8" data-id="element-30">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-3" data-id="element-31">
            ¿Qué agrega el{' '}
            <span className="text-[#FF6B00]" data-id="element-32">Kit Táctico Pro?</span>
          </h2>
          <p className="text-[#B0B0C0] text-base max-w-xl mx-auto" data-id="element-33">
            Todo lo que necesitas para competir como profesional.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-34">
          {features.map(f => <div key={f.title} className="bg-[#16161F] border border-[#FF6B0033] rounded-xl p-4 flex items-start gap-3" data-id="element-35">
              <span className="text-2xl flex-shrink-0" data-id="element-36">{f.icon}</span>
              <div data-id="element-37">
                <h4 className="text-white font-bold text-sm" data-id="element-38">{f.title}</h4>
                <p className="text-[#B0B0C0] text-sm mt-0.5" data-id="element-39">{f.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}